/* CelluMove — our own bundle selector (snippets/cm-bundle.liquid). No Kaching JS: ATC posts the line property Kaching's
   server-side discount function reads, then opens the theme's cart drawer. */
(function () {
  if (customElements.get('cm-bundle')) return;
  var GBP = window.cmBase || 'GBP';  // store base currency (theme setting cm_base_currency)
  function cur() { try { return (Shopify.currency && Shopify.currency.active) || GBP; } catch (e) { return GBP; } }
  function money(c) { return window.cmMoney ? cmMoney(c) : '£' + (c / 100).toFixed(2); }
  // a computed per-unit amount (tier price / units) in a currency priced in whole units (CZK, HUF: '417 Kč', not '416,67 Kč';
  // ORGANIZER 29/10, THEME CZ): rounded to the unit, no ',00'; checkout amounts stay Shopify's
  function unitMoney(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    if (!/^(CZK|HUF)$/.test(cur)) return money(c);
    return money(Math.round(c / 100) * 100).replace(/([.,]00)(?=\D*$)/, '');
  }
  function rate() { return window.cmRate ? cmRate() : 1; }
  function rid() { return Math.random().toString(36).slice(2, 6).toUpperCase(); }
  function bucket() {
    var k = 'cm_kab', b;
    try { b = parseFloat(localStorage.getItem(k)); } catch (e) {}
    if (!(b >= 0 && b < 100)) { b = Math.random() * 100; try { localStorage.setItem(k, b); } catch (e) {} }
    return b;
  }
  // Kaching's swatch colours for names CSS doesn't know, CSS colour names otherwise
  var SW = { 'light purple': '#D8C4E8', burgundy: '#800020', 'army green': '#4B5320', onyx: '#353839', 'lipstick red': '#C41E3A', 'mist pink': '#E8C7CC', matcha: '#A8B98A', 'powder blue': '#B0D0E8', 'heather grey': '#B9B6B6', 'light heather grey': '#D4D1D1', 'dusty rose': '#C99A9E', nude: '#E3BC9A', 'classic black': '#111111', 'olive green': '#708238', plum: '#8E4585', 'soft magenta pink': '#E79FC4', 'navy blue': '#1F2A44' };
  // market stores show translated colour names (QA SITE 29/10: grey dots on PT / ES / PL / GR): translated name -> the English name above
  // (keys lower case, accents removed; one line per English colour; add names here when a market adds a colour)
  var TR = {};
  [['black', 'preto|negro|schwarz|noir|noire|cerna|cerny|czarny|czarne|μαυρο|nero'],
   ['white', 'branco|blanco|weiss|weiß|blanc|blanche|bila|bily|bialy|biale|λευκο|ασπρο|bianco'],
   ['beige', 'bege|bezova|bezowy|bezowe|μπεζ'],
   ['pink', 'rosa|rose|ruzova|rozowy|rozowe|ροζ'],
   ['light pink', 'rosa claro|rosa clara|hellrosa|rose clair|rose pale|svetle ruzova|svetlе ruzova|jasnorozowy|jasnorozowe|απαλο ροζ|ανοιχτο ροζ'],
   ['blue', 'azul|blau|bleu|modra|niebieski|niebieskie|μπλε|blu'],
   ['powder blue', 'azul claro|azul bebe|azul polvo|puderblau|hellblau|bleu poudre|bleu ciel|pudrova modra|svetle modra|blekit pudrowy|jasnoniebieski|γαλαζιο'],
   ['navy', 'azul marinho|azul marino|marineblau|bleu marine|namornicka modra|tmave modra|granatowy|granat|μπλε ναυτικο'],
   ['purple', 'roxo|morado|lila|violett|violet|fialova|fioletowy|fioletowe|μωβ'],
   ['light purple', 'roxo claro|lilas|morado claro|lila claro|hellviolett|helllila|violet clair|mauve|svetle fialova|jasnofioletowy|jasnofioletowe|ανοιχτο μωβ|lavanda|lavande|lavendel'],
   ['burgundy', 'bordo|bordeaux|bordeus|burdeos|borgona|granate|vinova|bordowy|burgundia|βουργουνδια|μπορντο'],
   ['grey', 'cinzento|cinza|gris|grau|seda|sedy|szary|szare|γκρι|grigio'],
   ['brown', 'castanho|marrom|marron|braun|hneda|hnedy|brazowy|brazowe|καφε'],
   ['army green', 'verde militar|verde exercito|verde tropa|armeegrun|olivgrun|olive|vert armee|vert kaki|kaki|khaki|vojenska zelena|zielen wojskowa|wojskowa zielen|στρατιωτικο πρασινο'],
   ['green', 'verde|grun|vert|zelena|zielony|zielone|πρασινο'],
   ['red', 'vermelho|rojo|rot|rouge|cervena|czerwony|κοκκινο|rosso'],
   ['yellow', 'amarelo|amarillo|gelb|jaune|zluta|zolty|κιτρινο'],
   ['onyx', 'onix|onyks|ονυχας'],
   ['black', 'schwarz-black|μαυρος'],
   ['white', 'biel|λευκη'],
   ['purple', 'purpura|roxa|μοβ|violette'],
   ['yellow', 'amarilla|κιτρινος'],
   ['army green', 'vert militaire'],
   ['brown', 'brun'],
   // 30/10: LOCALIZE's option value translations (product_options_fix_3010)
   ['nude', 'cielisty|chair|χρωμα δερματος'],
   ['dusty rose', 'rosa velho'],
   ['heather grey', 'cinzento mesclado'],
   ['olive green', 'verde azeitona'],
   // 30/10 (QA SITE / THEME CZ): every colour value of LOCALIZE's fix file (new + current) resolves to a dot
   ['classic black', 'klasicka cerna'],
   ['soft magenta pink', 'jemna purpurove ruzova'],
   ['burgundy', 'borgundske|burgundsko'],
   ['beige', 'bezovy'],
   ['khaki', 'chaki'],
   ['nude', 'obnazeny/obnazena|obnazeny|obnazena|telova'],
   ['pink', 'ruzovy'],
   ['brown', 'kastanove hnedy'],
   ['blue', 'modry'],
   ['cyan', 'cian'],
   ['olive green', 'oliva|λαδι|oliwkowy'],
   ['light pink', 'παλ ροζ'],
   ['coral', 'koralowy'],
   ['dusty rose', 'pudrowy roz'],
   ['plum', 'sliwkowy'],
   ['burgundy', 'bourgogne|burgund|burgunder|borgonha|bordeaux rot'],
   ['light pink', 'zartrosa'],
   ['powder blue', 'azul empolvado|azul-celeste|azul celeste'],
   ['light purple', 'jasny fiolet|jasno fioletowy|jasny fioletowy'],
   ['pink', 'cor-de-rosa|cor de rosa'],
   ['navy blue', 'marine|azul-marinho|granatowe|μπλε μαρεν|ναυτικο|navy blue'],
   ['heather grey', 'gris chine|cinzento heather|gris jaspeado|grau meliert'],
   ['light heather grey', 'jasnoszary melanz|ανοιχτο γκρι μελανζε'],
   ['dusty rose', 'rose poudre|rosa empoeirado|zakurzony roz|rosa empolvado|altrosa|σκουροχρωμο ροζ'],
   ['nude', 'nu|nue|nackt|desnudo|nagi|γυμνος|nua'],
   ['classic black', 'classicblack|klasyczna czern|preto classico|classico preto|κλασικο μαυρο|noir classique|klassisches schwarz'],
   ['olive green', 'oliwka|azeitona|ελια|olive'],
   ['plum', 'prune|sliwka|ameixa|δαμασκηνο|ciruela|pflaume'],
   ['coral', 'corail|koral|κοραλι|koralle'],
   ['cyan', 'cyjan|ciano|κυανο'],
   ['khaki', 'caqui|χακι'],
   ['soft magenta pink', 'rose magenta doux|delikatny rozowy magenta|subtelna rozowa magenta|rosa magenta suave|rosa-magenta suave|απαλο ματζεντα ροζ']
  ].forEach(function (r) { r[1].split('|').forEach(function (t) { TR[t] = r[0]; }); });
  function norm(k) { return k.normalize ? k.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l') : k; }
  ['czarno', 'bialo', 'granatowo', 'cerno', 'bilo', 'schwarzweiss'].forEach(function (t, i) { TR[t] = ['black', 'white', 'navy', 'black', 'white', 'black'][i]; });
  function one(k) {
    k = k.replace(/-\d+$/, '').trim();                      // 'Schwarz-2', 'noir-2' (duplicate values)
    var par = /\(([^)]+)\)/.exec(k); if (par) { var pc = one(par[1].toLowerCase()); if (pc) return pc; k = k.replace(/\s*\([^)]*\)/, ''); }  // 'Schwarz (Black)'
    k = TR[k] || TR[norm(k)] || k;
    var c = SW[k] || k.replace(/\s+/g, '');
    return (window.CSS && CSS.supports && CSS.supports('color', c)) ? c : null;
  }
  function swatch(n) {
    var k = String(n).toLowerCase().trim(), c = one(k);
    if (c) return c;
    // two-colour names ('black & white', 'Czarno-biały', 'Granatowy i biały', 'Negro y blanco'...): a split dot (ORGANIZER 29/10)
    if (/^ασπρομαυρ/.test(norm(k))) return 'linear-gradient(135deg,black 50%,white 50%)';
    var seps = [/\s*(?:&|\+|\/|\s(?:and|i|y|e|et|und|a|και)\s)\s*/, /\s*-\s*/];
    for (var i = 0; i < seps.length; i++) {
      var p = k.split(seps[i]);
      if (p.length === 2) { var a = one(p[0]), b = one(p[1]); if (a && b) return 'linear-gradient(135deg,' + a + ' 50%,' + b + ' 50%)'; }
    }
    return '#C9C2C5';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  class CmBundle extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      var j = function (s) { var e = this.querySelector(s); return e ? JSON.parse(e.textContent) : null; }.bind(this);
      this.variants = j('[data-cmb-variants]') || [];
      this.options = j('[data-cmb-options]') || [];
      this.deal = j('[data-cmb-deal]') || {};
      this.pid = +this.dataset.productId;
      this.picks = [];
      this.pickSet();
      this.localPrices();
      this.sub = this.querySelector('[data-cmb-sub]');
      if (this.sub) { this.subPrices(); this.sub.querySelector('input').addEventListener('change', function () { this.subPrices(); this.updateAtc(); }.bind(this)); }
      this.addEventListener('change', function (e) {
        if (e.target.matches('input[type=radio]')) this.renderUnits();
        else if (e.target.matches('select[data-unit]')) { this.readPicks(); this.paintUnit(e.target.closest('[data-cmb-unit]')); this.updateAtc(); }
      }.bind(this));
      this.addEventListener('click', function (e) {
        var row = e.target.closest('[data-cmb-gift-row]'), g = row && row.querySelector('[data-cmb-gift]');
        if (g) {  // gift explainer (Farid 26/10): a tap anywhere on the gift row (photo, name, ⓘ) opens it
          e.preventDefault();
          var info = row.querySelector('.cmb__gift-info'), open = g.getAttribute('aria-expanded') !== 'true';
          g.setAttribute('aria-expanded', open); if (info) info.hidden = !open;
          return;
        }
        // a tap anywhere on a tier (gifts, highlights) selects it, like Kaching; pickers keep working
        var bar = e.target.closest('.cmb__bar'), r = bar && bar.querySelector('input[type=radio]');
        if (r && !r.checked && !e.target.closest('select,label,button,a')) { r.checked = true; this.renderUnits(); }
      }.bind(this));
      this.querySelector('[data-cmb-atc]').addEventListener('click', this.add.bind(this));
      this.renderUnits();
      // Add to cart tapped before this script arrived (snippets/cm-bundle.liquid): run it now
      if (this.dataset.cmbPending) { delete this.dataset.cmbPending; this.add(); }
    }
    // Kaching A/B variant: same ranges as Kaching (abTestVariantRange), bucket kept per visitor
    pickSet() {
      var b = bucket(), sets = [].slice.call(this.querySelectorAll('.cmb__set')), pick = sets[0];
      sets.forEach(function (s) {
        var v = this.deal.variants && this.deal.variants[s.dataset.ab];
        if (v && v.range && b >= v.range[0] && b < v.range[1]) pick = s;
      }, this);
      sets.forEach(function (s) { s.hidden = s !== pick; });
      this.set = pick; this.ab = pick ? pick.dataset.ab : 'A';
      this.cfg = (this.deal.variants || {})[this.ab] || {};
    }
    // bundle totals are GBP (Kaching): convert on other currencies, hide a struck price that isn't higher
    localPrices() {
      var c = cur(), r = rate(), nat = !!(this.deal && this.deal.cur && this.deal.cur === c);
      this.querySelectorAll('[data-cmb-gbp]').forEach(function (e) {
        // a market's own Kaching deal (28/10, e.g. USA 0WlA) is priced in that market's currency already: its tier prices aren't converted
        var v = +e.dataset.cmbGbp; if (c !== GBP && !(nat && e.closest('.cmb__price') && !e.hasAttribute('data-cmb-cmp'))) v = Math.round(v * r);
        e.dataset.cents = v; e.textContent = money(v);
      });
      if (c !== GBP) this.querySelectorAll('[data-cm-gbp]').forEach(function (e) {
        e.innerHTML = e.innerHTML.replace(/£\s?(\d+(?:\.\d{1,2})?)/g, function (_, v) { return money(Math.round(parseFloat(v) * 100 * r)); });
      });
      // per-unit labels in Kaching titles ("Only £14.98 Each", "16.65 € pro Stück", "$26.6/Legging") are typed by hand and go stale
      // (QA DE 28/10: a set-B tier showed another product's figure): always show tier price / units, in the store's money format
      var PER = /each|per\b|por\b|\/|st[üu]ck|pi[eè]ce|cada|par |l.unit|unidad|c\/u|za kus|\bks\b|kus/i, SAVE = /sav|spar|ahorr|[ée]conom|u[sš]et/i;
      var AMT = /(?:US)?[£$€]\s?\d+(?:[.,]\d{1,2})?|\d+(?:[.,]\d{1,2})?\s?(?:€|Kč|£|\$)/g;
      this.querySelectorAll('.cmb__bar').forEach(function (bar) {
        var p = bar.querySelector('.cmb__price [data-cents]'), q = +bar.dataset.qty || 1;
        if (!p || q < 2) return;
        bar.querySelectorAll('.cmb__name, .cmb__label, .cmb__sub').forEach(function (e) {
          var t = e.textContent;
          if (!PER.test(t) || SAVE.test(t) || !AMT.test(t)) return;
          AMT.lastIndex = 0;
          e.innerHTML = e.innerHTML.replace(AMT, function () { return unitMoney(Math.round(+p.dataset.cents / q)); });
        });
      });
      // single-unit anchor (Farid 362/365): strike = this set's own 1X price × units; the 1X tier itself never shows a strike
      if (this.hasAttribute('data-anchor-1x')) this.querySelectorAll('.cmb__set').forEach(function (set) {
        var one = set.querySelector('.cmb__bar[data-qty="1"] .cmb__price [data-cents]');
        if (!one) return;
        var u = +one.dataset.cents;
        set.querySelectorAll('.cmb__bar').forEach(function (bar) {
          var s = bar.querySelector('[data-cmb-cmp]'), q = +bar.dataset.qty;
          if (!s) return;
          if (q === 1) { s.hidden = true; s.dataset.cmbCmp = 0; return; }
          s.dataset.cents = s.dataset.cmbCmp = u * q; s.textContent = money(u * q);
        });
      });
      this.querySelectorAll('.cmb__bar').forEach(function (bar) {
        var p = bar.querySelector('.cmb__price [data-cents]'), s = bar.querySelector('[data-cmb-cmp]');
        if (s && s.dataset.cents) s.dataset.cmbCmp = s.dataset.cents;  // base-currency anchor converted above
        if (p && s && +s.dataset.cmbCmp <= +p.dataset.cents) s.hidden = true;
      });
      // Kaching text variables (store app data, e.g. DE 'Du sparst {{saved_total}}', 'Nur {{new_price}} pro Stück') were printed raw (THEME DE 28/10)
      this.querySelectorAll('.cmb__bar').forEach(function (bar) {
        var pe = bar.querySelector('.cmb__price [data-cents]'), se = bar.querySelector('[data-cmb-cmp]'), q = +bar.dataset.qty || 1;
        if (!pe) return;
        var pr = +pe.dataset.cents, st = se ? +se.dataset.cmbCmp || 0 : 0, sv = Math.max(0, st - pr);
        bar.querySelectorAll('.cmb__name, .cmb__label, .cmb__sub, .cmb__badge').forEach(function (e) {
          if (e.innerHTML.indexOf('{{') < 0) return;
          var unit = PER.test(e.textContent);
          e.innerHTML = e.innerHTML
            .replace(/\{\{\s*new_price\s*\}\}/g, unit ? unitMoney(Math.round(pr / q)) : money(pr))
            .replace(/\{\{\s*(?:price_per_item|unit_price)\s*\}\}/g, unitMoney(Math.round(pr / q)))
            .replace(/\{\{\s*original_price\s*\}\}/g, st ? money(st) : '')
            .replace(/\{\{\s*saved_total\s*\}\}/g, money(sv))
            .replace(/\{\{\s*saved_percentage\s*\}\}/g, st ? Math.round(sv * 100 / st) + '%' : '')
            .replace(/\{\{[^}]*\}\}/g, '');
        });
      });
    }
    bar() { var i = this.set && this.set.querySelector('input:checked'); return i ? i.closest('.cmb__bar') : null; }
    readPicks() {
      var rows = this.querySelectorAll('[data-cmb-unit]'), picks = [];
      rows.forEach(function (row) { picks.push([].map.call(row.querySelectorAll('select'), function (s) { return s.value; })); });
      this.picks = picks;
    }
    // one option + one variant = Shopify's 'Default Title' product, whatever the store's language calls that option (Título / Titel / Titre...: THEME ES 29/10)
    single() { return this.options.length === 1 && this.variants.length === 1; }
    variantFor(opts) {
      return this.variants.find(function (v) { return v.o.every(function (o, i) { return o === opts[i]; }); });
    }
    // per-unit pickers inside the selected tier, Kaching layout: "Color, Size, Style" line, then one row per unit with its variant photo
    renderUnits() {
      var bar = this.bar(), qty = bar ? +bar.dataset.qty : 1, many = this.cfg.different_variants !== false && qty > 1;
      var rows = many ? qty : 1, first = (this.variants.find(function (v) { return v.a; }) || this.variants[0] || { o: [] }).o;
      this.querySelectorAll('[data-cmb-slot]').forEach(function (s) { s.innerHTML = ''; });
      var box = bar && bar.querySelector('[data-cmb-slot]'), html = '';
      if (!box || this.single()) { this.updateAtc(); return; }
      // the legging's 3rd option is named "Styke" in Shopify (typo in the product data): shown as "Style"
      // option names are the store's English product data: shown through snippets/cm-opt-label (LOCALIZE translates it, 28/10)
      var COLOR_RE = /^(colou?r|couleur|farbe|colore|kolor|barva|cor|χρώμα)$/i;
      var OPT = {}; try { OPT = JSON.parse((document.querySelector('[data-cm-opt]') || {}).textContent || '{}'); } catch (e) {}
      var label = function (n) {
        var k = COLOR_RE.test(n) ? 'color' : /^(size|taille|gr(ö|o)(ss|ß)e|talla|tama(ñ|n)o|rozmiar|velikost|tamanho|μέγεθος)$/i.test(n) ? 'size' : /^(sty(le|ke)|stil|estilo|styl|στυλ)$/i.test(n) ? 'style' : null;
        return esc((k && OPT[k]) || String(n).replace(/^Styke$/i, 'Style'));
      };
      html += '<p class="cmb__names">' + this.options.map(label).join(', ') + '</p>';
      for (var u = 0; u < rows; u++) {
        var pick = this.picks[u] || this.picks[0] || first;
        html += '<div class="cmb__unit" data-cmb-unit><img class="cmb__vimg" alt="" width="40" height="40" loading="lazy">';
        this.options.forEach(function (name, i) {
          var vals = [], color = COLOR_RE.test(name) || /colou?r/i.test(name);
          this.variants.forEach(function (v) { if (vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
          html += '<label class="cmb__sel' + (color ? ' cmb__sel--c' : '') + '">' + (color ? '<span class="cmb__sw" aria-hidden="true"></span>' : '') +
            '<span class="visually-hidden">' + label(name) + '</span><select data-unit="' + u + '"' + (color ? ' data-color' : '') + ' aria-label="' + label(name) + (many ? ' #' + (u + 1) : '') + '">';
          vals.forEach(function (val) {
            var test = pick.slice(); test[i] = val;
            var v = this.variantFor(test), soldout = v && !v.a;
            html += '<option value="' + esc(val) + '"' + (val === pick[i] ? ' selected' : '') + '>' + esc(val) + (soldout ? ' (' + esc(OPT.sold_out || 'sold out') + ')' : '') + '</option>';
          }, this);
          html += '</select></label>';
        }, this);
        html += '</div>';
      }
      box.innerHTML = html;
      this.readPicks();
      box.querySelectorAll('[data-cmb-unit]').forEach(this.paintUnit, this);
      this.updateAtc();
    }
    // row photo = the picked variant's image, colour dot = the picked colour
    paintUnit(row) {
      if (!row) return;
      var opts = [].map.call(row.querySelectorAll('select'), function (s) { return s.value; }), v = this.variantFor(opts);
      var im = row.querySelector('.cmb__vimg'); if (im && v && v.i) im.src = v.i;
      var c = row.querySelector('select[data-color]'), sw = row.querySelector('.cmb__sw');
      if (c && sw) sw.style.background = swatch(c.value);
    }
    lines() {
      var bar = this.bar(), qty = bar ? +bar.dataset.qty : 1, picks = this.picks.length ? this.picks : [[]], ids = {};
      for (var u = 0; u < qty; u++) {
        var v = this.single() ? this.variants[0] : this.variantFor(picks[u] || picks[0]);
        if (!v || !v.a) return null;
        ids[v.id] = (ids[v.id] || 0) + 1;
      }
      return ids;
    }
    // Auto-Refill ticked: tier prices shown with the selling plan's % off (Kaching shows the same)
    subPrices() {
      var on = this.sub.querySelector('input').checked, f = 1 - (+this.sub.dataset.pct || 0) / 100;
      this.querySelectorAll('.cmb__bar .cmb__price [data-cents]').forEach(function (e) {
        if (!e.dataset.base) e.dataset.base = e.dataset.cents;
        var v = on ? Math.round(+e.dataset.base * f) : +e.dataset.base;
        e.dataset.cents = v; e.textContent = money(v);
      });
    }
    updateAtc() {
      var ok = !!this.lines(), b = this.querySelector('[data-cmb-atc]'), l = this.querySelector('[data-cmb-atc-label]');
      b.disabled = !ok; var T = window.cmT || {}; l.textContent = ok ? (T.atc || 'Add to cart') : (T.soldPick || 'Sold out: pick another size');
      // live V1 button: "ADD TO CART — £49.95 £314.55" (tier price, struck = tier compare-at + gifts)
      var pe = this.querySelector('[data-cmb-atc-p]'), bar = this.bar();
      if (pe) {
        var p = bar && bar.querySelector('.cmb__price [data-cents]'), c = bar && bar.querySelector('[data-cmb-cmp]'), html = '';
        if (ok && p && p.dataset.cents) {
          var cmp = (c && !c.hidden ? +c.dataset.cmbCmp : (p ? +p.dataset.cents : 0)) + (+bar.dataset.giftCmp || 0) + Math.round((+bar.dataset.giftCmpBase || 0) * (cur() !== GBP ? rate() : 1));
          // anchor setting off = old Kaching button: struck = the tier's compare-at only, no gifts, none when the variant has no compare-at
          if (!this.hasAttribute('data-anchor-1x')) cmp = bar.hasAttribute('data-cmp-real') && c && !c.hidden ? +c.dataset.cmbCmp : 0;
          html = '<span class="cmb__atc-sep">—</span><b>' + money(+p.dataset.cents) + '</b>' + (cmp > +p.dataset.cents ? '<s>' + money(cmp) + '</s>' : '');
        }
        pe.innerHTML = html;
      }
      this.querySelector('[data-cmb-err]').hidden = true;
    }
    add() {
      // cm-bundle.js is async now: the theme's cart drawer may not be defined yet on a very early tap
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.getSectionsToRender !== 'function') { customElements.whenDefined('cart-drawer').then(this.add.bind(this)); return; }
      var ids = this.lines(), bar = this.bar(); if (!ids || !bar) return;
      // same line properties as Kaching's widget: main lines carry the tier (bid), gift lines the gift id, all share one group id
      var gid = rid(), deal = this.deal.deal, v = this.cfg.v || undefined, bid = bar.dataset.bid;
      var prop = JSON.stringify({ deal: deal, pp: this.pid, main: true, v: v, id: gid, bid: bid, abid: this.cfg.abid || undefined, ab: this.cfg.abid ? this.ab : undefined });
      // _cm_* = hidden line properties for A/B reads (Farid 26/10, item 11): tier, gift line, where the add came from
      var tier = bar.dataset.qty + 'X';
      var plan = this.sub && this.sub.querySelector('input').checked ? +this.sub.dataset.plan : 0;
      var items = Object.keys(ids).map(function (id) { var it = { id: +id, quantity: ids[id], properties: { __kaching_bundles: prop, _cm_tier: tier, _cm_src: 'bundle' } }; if (plan) it.selling_plan = plan; return it; });
      ((this.cfg.bars || []).find(function (b) { return b.bid === bid; }) || { gifts: [] }).gifts.forEach(function (g) {
        if (g.variant) items.push({ id: g.variant, quantity: g.qty || 1, properties: { __kaching_bundles: JSON.stringify({ id: gid, deal: deal, v: v, gift: g.id }), _cm_tier: tier, _cm_src: 'bundle', _cm_gift: '1' } });
      });
      var drawer = document.querySelector('cart-drawer'), btn = this.querySelector('[data-cmb-atc]'), err = this.querySelector('[data-cmb-err]');
      var body = { items: items };
      if (drawer) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
      btn.disabled = true; btn.classList.add('is-loading');
      // 29/10 (Farid 'the UK cart takes time to open', SITE: 1.2-1.8 s on 4G, all Shopify's add.js): the drawer opens on the tap with a
      // loading state (cm-adding) and fills in when add.js answers; on an error it closes again and the message shows under the button
      if (drawer && drawer.open) { drawer.classList.add('cm-adding'); drawer.open(btn); }
      var done = function () { drawer && drawer.classList.remove('cm-adding'); };
      var url = (window.routes && routes.cart_add_url || '/cart/add') + '.js';
      var post = function () { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); };
      post()
        .then(function (r) { return r.status === 429 ? new Promise(function (ok) { setTimeout(ok, 1500); }).then(post) : r; })  // one retry when Shopify throttles
        .then(function (r) { return r.json(); })
        .then(function (r) {
          // 28/10 (Farid, US): Shopify refuses the whole add when one gift variant is sold out ("... is already sold out").
          // The leggings must still go in: re-add the paid lines alone, then each gift on its own (a refused gift is skipped).
          var gifts = items.filter(function (it) { return it.properties._cm_gift; });
          if (!r.status || !gifts.length) return r;
          var add = function (list) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({}, body, { items: list })) }).then(function (x) { return x.json(); }); };
          return add(items.filter(function (it) { return !it.properties._cm_gift; })).then(function (m) {
            if (m.status) return m;
            return gifts.reduce(function (p, g) { return p.then(function (last) { return add([g]).then(function (x) { return x.status ? last : x; }); }); }, Promise.resolve(m));
          });
        })
        .then(function (r) {
          if (r.status) { done(); drawer && drawer.close(); err.textContent = r.description || r.message || ((window.cmT || {}).err || 'Something went wrong, please try again.'); err.hidden = false; return; }
          document.dispatchEvent(new CustomEvent('cm:bundle-added', { detail: { items: items } }));
          if (window.cmCartArm) cmCartArm();
          if (drawer) { drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty'); drawer.renderContents(r); done(); }
          else location.href = (window.routes && routes.cart_url) || '/cart';
        })
        .catch(function () { done(); drawer && drawer.close(); err.textContent = (window.cmT || {}).net || 'Network error, please try again.'; err.hidden = false; })
        .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    }
  }
  customElements.define('cm-bundle', CmBundle);
})();
